import TrucksList from 'components/TrucksList'
import React from 'react'

type Props = {
  marketName: string
  marketId: number
}

const TrucksSection = ({ marketName, marketId }: Props) => {
  return (
    <div className="w-full mx-auto bg-gradient-to-b from-white to-gray-50 pb-10">
      <div className="max-w-screen-lg mx-auto md:px-4 pt-4">
        <div className="flex flex-col items-center my-10">
          <h1 className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
            Food Trucks in {marketName}
          </h1>
        </div>

        {/* {market.descriptionHtml && market.descriptionHtml.length > 0 && ( */}
        {/*  <div */}
        {/*    className="prose max-w-none md:px-0 px-4 mb-12" */}
        {/*    // eslint-disable-next-line react/no-danger */}
        {/*    dangerouslySetInnerHTML={{ */}
        {/*      // eslint-disable-next-line react/no-danger */}
        {/*      __html: market.descriptionHtml */}
        {/*    }} */}
        {/*  /> */}
        {/* )} */}

        <TrucksList marketId={marketId} />
      </div>
    </div>
  )
}

export default TrucksSection
